import gmIcon from "@/assets/icons/franchises/gm.svg";
import mmIcon from "@/assets/icons/franchises/mm.svg";
import volvoIcon from "@/assets/icons/franchises/volvo_text.svg";
import stellantisIcon from "@/assets/icons/franchises/st.svg";
import cadillacIcon from "@/assets/icons/franchises/cadillac_text.svg";
import chevroletIcon from "@/assets/icons/franchises/chevrolet_text.svg";
import alfaRomeoIcon from "@/assets/icons/franchises/alfa_romeo_icon.svg";
import chryslerIcon from "@/assets/icons/franchises/chrysler_icon.svg";
import dodgeIcon from "@/assets/icons/franchises/Dodge.svg";
import fiatIcon from "@/assets/icons/franchises/Fiat.svg";
import jeepIcon from "@/assets/icons/franchises/Jeep.svg";
import ramIcon from "@/assets/icons/franchises/Ram.svg";
import buickLogo from "@/assets/icons/franchises/buick_text.svg";
import gmcLogo from "@/assets/icons/franchises/gmc_icon.svg";

export const iconsMap: { [key: string]: string } = {
	gm: gmIcon,
	mm: mmIcon,
	"volvo cars": volvoIcon,
	volvo: volvoIcon,
	st: stellantisIcon,
	mitsubishi: mmIcon,
	cadillac: cadillacIcon,
	chevrolet: chevroletIcon,
	"alfa romeo": alfaRomeoIcon,
	fiat: fiatIcon,
	chrysler: chryslerIcon,
	dodge: dodgeIcon,
	jeep: jeepIcon,
	ram: ramIcon,
	buick: buickLogo,
	gmc: gmcLogo,
};
